/*
 * Copyright (C) 2022 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import React, { useEffect } from 'react';
import { View } from '@instructure/ui-view';
import { Text } from '@instructure/ui-text';
import { Flex } from '@instructure/ui-flex';
import { TextInput } from '@instructure/ui-text-input';
import formatMessage from '../../../format-message';
import { showFlashAlert } from '../../../common/FlashAlert';
const EDIT_MESSAGE = formatMessage('If left empty, link text will display as course link name');
export const LinkDisplay = _ref => {
  let {
    linkText,
    Icon,
    placeholderText,
    linkFileName,
    published,
    handleTextChange
  } = _ref;
  useEffect(() => {
    showFlashAlert({
      message: formatMessage('Selected {linkFileName}', {
        linkFileName
      }),
      type: 'info',
      srOnly: true
    });
  }, [linkFileName]);
  return /*#__PURE__*/React.createElement(View, {
    as: "div",
    "data-testid": "LinkDisplay"
  }, /*#__PURE__*/React.createElement(View, {
    as: "div"
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(TextInput, {
    renderLabel: () => formatMessage('Text (optional)'),
    onChange: (e, value) => handleTextChange(value),
    value: linkText,
    placeholder: placeholderText,
    messages: [{
      type: 'hint',
      text: EDIT_MESSAGE
    }]
  })))), /*#__PURE__*/React.createElement(View, {
    as: "div",
    margin: "medium none medium none"
  }, /*#__PURE__*/React.createElement(Flex, {
    margin: "small none small none"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Current Link")), /*#__PURE__*/React.createElement(Flex, {
    margin: "small none none none"
  }, /*#__PURE__*/React.createElement(Flex.Item, {
    padding: "0 x-small 0 small"
  }, /*#__PURE__*/React.createElement(Text, {
    "data-testid": "icon-wrapper",
    color: published ? 'success' : 'primary'
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "x-small"
  }))), /*#__PURE__*/React.createElement(Flex.Item, {
    padding: "0 x-small 0 0",
    grow: true,
    shrink: true,
    textAlign: "start"
  }, /*#__PURE__*/React.createElement(View, {
    as: "div"
  }, /*#__PURE__*/React.createElement("span", {
    "data-testid": "selected-link-name"
  }, linkFileName))))));
};